<script>
  import { Bar } from 'vue-chartjs'
  import VueCharts from 'vue-chartjs'


  export default {
    extends: Bar,
    mixins: [VueCharts.mixins.reactiveProp],
    prop: ['chartData'],
    data: () => ({
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              stepSize: 25,
              maxTicksLimit: 10,
              max: 100,
              beginAtZero: true,
              min: 0
            }
          }]
        },
        legend: {
          display: false
        },
        layout: {
          padding: {
            left: 10,
            right: 0,
            top: 10,
            bottom: 0
          }
        },
        plugins: {
          datalabels: {
            color: '#040080',
            font: {weight: 'bold', size: '50', family: "'Arimo', sans-serif"},
            formatter: function (value) {
              if (avg == 0) {
                return ''
              }
              return Math.round(value) + '%';
            },
            anchor: 'center',
            align: 'center'
          }
        },
        tooltips: {
          custom: function (tooltip) {
          },
          mode: 'single',
          callbacks: {
            label: function (tooltipItems, data) {
              return Math.round((data.datasets[0].data[tooltipItems.index])) + ' %';
            },
            beforeLabel: function () {
              return 'Average leads';
            }
          }
        }
      }
    }),
    mounted () {
      // Overwriting base render method with actual data.
      this.renderChart(this.chartData, this.options);
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/a_generalDashboard/Card3.vue